// extracted by mini-css-extract-plugin
export default {"page":"minesweeper_page__zYodk","contents":"minesweeper_contents__dBOT8"};